import { render, staticRenderFns } from "./home-about-v2.vue?vue&type=template&id=723aff00&scoped=true&"
import script from "./home-about-v2.vue?vue&type=script&lang=js&"
export * from "./home-about-v2.vue?vue&type=script&lang=js&"
import style0 from "./home-about-v2.vue?vue&type=style&index=0&id=723aff00&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723aff00",
  null
  
)

export default component.exports